import FieldError from "app/common/FieldError";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Api, { createFetchErrorMessage } from "utils/api/Api";
import { toast } from 'react-toastify';
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const UserBookCreateForm = ({ creative = 'N', onCancel = f => f }) => {
    const navigate = useNavigate();
    const { school } = useParams();
    const queryClient = useQueryClient();

    const [subject, setSubject] = useState('');
    const [errors, setErrors] = useState([]);

    const userBookStoreMutate = useMutation({
        mutationFn: (data) => Api.post('/api/userBook/store', data),
        onSuccess: (res) => {
            queryClient.invalidateQueries({ queryKey: ['userbook/list', { page: 0, list: "my", keyword: "", sort: "updatedAt,desc", creative: "N" }] });
            queryClient.invalidateQueries({ queryKey:['user/book/my/summary']});
            navigate({ pathname: `/${school}/userbook/ready/${res.data}`, search: '' });
        },
        onError: (err) => {
            const errorData = createFetchErrorMessage(err);
            if (errorData.errors.length > 0) {
                setErrors(errorData.errors);
            } else {
                toast.error(errorData.message);
            }
        }
    });

    const onStore = () => {
        if (userBookStoreMutate.isPending) return;
        if (subject === '') {
            setErrors([{ field: 'subject', 'reason': '작품 제목을 적어주세요.' }])
            return;
        }
        userBookStoreMutate.mutate({ subject: subject, creative, id: '' });
    }

    return (
        <div className="step inner inputStep">
            <div className="row">
                <div className="col6 col-sm-12 guideContainer ">
                    <div className="explain">
                        <strong>먼저,<br />제목을 정해주세요!</strong>
                        <p>자신의 작품과 관련된 제목으로~</p>
                    </div>
                </div>
                <div className="col6 col-sm-12 bookgomi">
                    <img src={`${process.env.PUBLIC_URL}/static/images/userbook/new_userbook_title_bookgomi.gif`} alt="북고미" />
                </div>
                <div className="col12">
                    <FieldError name="subject" errors={errors} >
                        <input type="text" maxLength="20" className="input_title" placeholder="여러분들의 작품 제목을 20자 이내로 입력해주세요." name="subject" value={subject} onChange={e => setSubject(e.target.value)} />
                    </FieldError>
                </div>
            </div>


            <button className="btn _blue" onClick={onStore}>다음</button>
            &nbsp;
            <button className="btn _gray" onClick={onCancel}>취소</button>
        </div>
    );
}